import React from 'react';
import Header2 from '../Common/Header2';
import Footer2 from '../Common/Footer2';
import SEO from '../Common/SEO';
import Slider2 from './../Elements/Slider2';
import About2 from './../Elements/About2';
import WhatWeDo2 from './../Elements/WhatWeDo2';
import WhatWeDo5 from './../Elements/WhatWeDo5';
import WhatWeDo6 from './../Elements/WhatWeDo6';
import Projects2 from './../Elements/Projects2';
import Services2 from './../Elements/Services2';
import Blog1 from './../Elements/Blog1';
import Statistics1 from './../Elements/Statistics1';
import Testimonials2 from './../Elements/Testimonials2';
import CountUp from 'react-countup';
import Team1 from './../Elements/Team1';
import { NavLink } from 'react-router-dom';
import ConsultationModal from '../Elements/ConsultationModal';
import WebsiteBanner from '../Elements/websitebanner';
var bgimg1 = require('./../../images/background/f-bg.jpg');
var bgimg2 = require('./../../images/background/bg-5.png');
var founderImg = require('./../../images/our-team5/r2.jpg');
var coFounderImg = require('./../../images/our-team5/p1.jpg');

class Home2 extends React.Component {
  
    constructor(props) {
    super(props);
    this.state = {
         isOpen: false,
      showModal: false,
      formData: {
        name: "",
        phone: "",
        email: "",
        service: [],
        city: "",
        message: "",
      }
    //  this.openModal = this.openModal.bind(this)
    };
  }
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');

    };
        openModal() {
        this.setState({ isOpen: true })
    }
    toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };
   resetForm = () => {
      this.setState({formData:{ name: "", phone: "", email: "", service: [], city: "", message: "" }});
    }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value }
    }));
  };

  handleServiceCheckbox = (e) => {
    const { value, checked } = e.target;
    this.setState((prev) => {
      let services = [...prev.formData.service];
      if (checked) {
        services.push(value);
      } else {
        services = services.filter((s) => s !== value);
      }
      return { formData: { ...prev.formData, service: services } };
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted:", this.state.formData);
    this.toggleModal();
  };

    render() {
        return (
            <>
                <SEO
                  titleExact
                  title="Infrio India – Architecture, Design & Build Experts"
                  description="Infrio India delivers premium architecture, interior design & building solutions. Our expert team blends creativity with functionality to create stunning residential, commercial and sustainable spaces that reflect your style and needs."
                  canonicalPath="/"
                  keywords="Infrio India, architecture services India, interior design firm Indore, residential interior designers, commercial architecture solutions, Infrio design build, sustainable architecture solutions, modern interior design services"
                />
                <Header2 />
                <div className="page-content">
                    <Slider2 />
                    <About2 onConsultationClick={this.toggleModal} />
                     {/* <Services2 /> */}
                    {/* <WhatWeDo2 /> */}
                        {/* <WhatWeDo5 /> */}
                            <WhatWeDo6 />
           <WebsiteBanner />                 
                    <Projects2 />

                      <Statistics1 />
                      <div className="section-full p-t50 p-b50 bg-white">
                        <div className="container">
                            <div className="section-head">
                                <div className="sx-separator-outer separator-center">
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + require('./../../images/background/cross-line2.png') + ')' }}>
                                        <h3 className="sep-line-one">Leadership &amp; Team</h3>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-lg-5 col-md-6 col-sm-12 m-b30">
                                    <div className="our-team-2 shadow-sm h-100">
                                        <div className="profile-image" style={{ width: '100%', height: '320px', overflow: 'hidden', borderRadius: '12px 12px 0 0' }}>
                                            <img src={founderImg} alt="Founder" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div className="figcaption text-black p-a25">
                                            <h4 className="m-t0">Rajesh Malav</h4>
                                            <span className="m-b15 d-block text-primary text-uppercase" style={{ letterSpacing: '1px', fontWeight: 600 }}>Founder &amp; Director</span>
                                            <p className="text-muted" style={{ lineHeight: 1.7 }}>
                                                With over 15 years of experience in architecture and turnkey construction, Rajesh leads Infrio’s vision of crafting functional, future-ready spaces.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-6 col-sm-12 m-b30">
                                    <div className="our-team-2 shadow-sm h-100">
                                        <div className="profile-image" style={{ width: '100%', height: '320px', overflow: 'hidden', borderRadius: '12px 12px 0 0' }}>
                                            <img src={coFounderImg} alt="Co-Founder" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        </div>
                                        <div className="figcaption text-black p-a25">
                                            <h4 className="m-t0">Pooja Malav</h4>
                                            <span className="m-b15 d-block text-primary text-uppercase" style={{ letterSpacing: '1px', fontWeight: 600 }}>Head of Architect & Interior Designing</span>
                                            <p className="text-muted" style={{ lineHeight: 1.7 }}>
                                            Pooja Malav, a Civil Engineering graduate from GSITS Indore, drives the design language at Infrio, blending aesthetics with practicality to deliver immersive interior experiences for every client.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Team1 embedded />
                        </div>
                    </div>
                    <Blog1 />
                        
                 <div className="section-full overlay-wraper sx-bg-secondry mobile-page-padding p-t80 p-b50 bg-parallax ml-auto" data-stellar-background-ratio="0.5" style={{ backgroundImage: 'url(' + bgimg1 + ')', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'repeat' }}>
                        <div className="overlay-main bg-black opacity-05" />
                        <div className="container">
                            <div className="section-content">
                                 <div className="counter-blocks-CTA text-center">
                                {/* <div  style={{ zIndex: 10, color: '#fff', fontFamily: '"Poppins", sans-serif' }}>Modish</div> */}
                                                                    {/* LAYER 4  Bold Title*/}
                                                                    <div style={{ zIndex: 10, textTransform: 'uppercase', whiteSpace: 'normal', fontWeight: 800, color: '#fff', fontFamily: '"Poppins", sans-serif', fontSize: 'clamp(1.5rem, 4vw, 2rem)', marginBottom: '20px' }}>Join us in inspiring dialogue</div>
                                                                    {/* LAYER 5  Paragraph*/}
                                                                    <div  style={{ zIndex: 10, whiteSpace: 'normal', color: '#fff', fontFamily: '"Poppins", sans-serif', fontSize: 'clamp(1rem, 2.5vw, 1.125rem)', lineHeight: '1.6', maxWidth: '800px', marginBottom: '30px', margin: '0 auto 30px auto' }}>Excited to meet you in person! Come visit us at our office to discuss your new design. We re looking forward to connecting face-to-face. See you soon</div>
                                                                    {/* LAYER 6  Read More*/}
                                                                    <div style={{ zIndex: 9 }}><NavLink onClick={this.toggleModal}  className="site-button btn-half"><span>Get a Free Consultation</span></NavLink></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Testimonials2 separatoralignment="separator-center" />
                </div>
 <ConsultationModal
          show={this.state.showModal}
          toggleModal={this.toggleModal}
          formData={this.state.formData}
          onResetForm={this.resetForm}
          handleChange={this.handleChange}
          handleServiceCheckbox={this.handleServiceCheckbox}
          handleSubmit={this.handleSubmit}
        />
                <Footer2 />
            </>
        );
    };
};

export default Home2;
